// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_container_home__jhQY3 {
  width: 60%;
    margin-top: 3%; 
  margin-left: 15%; 
  display: flex; 
  flex: 1 1; 
  flex-direction: column; 
  align-content: flex-start;
  align-items: flex-start;
  align-self: center;
}

.home_signup_block__TMgOT{
 display: flex ; 
 flex-direction: column; 
 align-items: center; 
 align-content: center;
 align-self: center;
}

.home_logos__XXZ7i {
  display: flex;
  flex: 1 1;
    align-content: flex-start;
  align-items: flex-start;
  align-self: center;
  vertical-align: bottom;

  width: 200px;
  height: 80px;
  margin-right: 15%; }

.home_imageGroup_department_logos__6QiS1 {
  display: flex; 
  flex: 1 1; 
  flex-direction: row; 
  align-content: flex-start;
  align-items: flex-start;
  align-self: flex-start;

}

.home_references_block__JTFcd {
  display: flex; 
  flex: 1 1; 
  flex-direction: row; 
  align-content: center;
  align-items: center;
  align-self: flex-start;
  justify-content:space-evenly; 
}


`, "",{"version":3,"sources":["webpack://./src/pages/Home/home.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;IACR,cAAc;EAChB,gBAAgB;EAChB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;EACE,aAAa;EACb,SAAO;IACL,yBAAyB;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;;EAEtB,YAAY;EACZ,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;;AAExB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B","sourcesContent":[".container_home {\r\n  width: 60%;\r\n    margin-top: 3%; \r\n  margin-left: 15%; \r\n  display: flex; \r\n  flex: 1; \r\n  flex-direction: column; \r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: center;\r\n}\r\n\r\n.signup_block{\r\n display: flex ; \r\n flex-direction: column; \r\n align-items: center; \r\n align-content: center;\r\n align-self: center;\r\n}\r\n\r\n.logos {\r\n  display: flex;\r\n  flex: 1;\r\n    align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: center;\r\n  vertical-align: bottom;\r\n\r\n  width: 200px;\r\n  height: 80px;\r\n  margin-right: 15%; }\r\n\r\n.imageGroup_department_logos {\r\n  display: flex; \r\n  flex: 1; \r\n  flex-direction: row; \r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: flex-start;\r\n\r\n}\r\n\r\n.references_block {\r\n  display: flex; \r\n  flex: 1; \r\n  flex-direction: row; \r\n  align-content: center;\r\n  align-items: center;\r\n  align-self: flex-start;\r\n  justify-content:space-evenly; \r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_home": `home_container_home__jhQY3`,
	"signup_block": `home_signup_block__TMgOT`,
	"logos": `home_logos__XXZ7i`,
	"imageGroup_department_logos": `home_imageGroup_department_logos__6QiS1`,
	"references_block": `home_references_block__JTFcd`
};
export default ___CSS_LOADER_EXPORT___;
